export default __webpack_public_path__ + "static/media/Saswatha Nithya Annadanam Trust.0f1eafa5.png";